import I18nContext from './I18nContext';
import { getSupportedLocales } from './helpers';
import { Translate, I18nProvider, useLocale, useTolgeeUpdates } from './components';
import { t } from './i18nEngine';

const locales = getSupportedLocales();

export { t, locales, I18nContext, Translate, I18nProvider, useLocale, useTolgeeUpdates };
